export default __webpack_public_path__ + "663e8e4a4065c5ac6c5e69addd2b6666.svg";